import React, { useEffect, useState } from "react";

import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import attendeAvatar from "assets/images/common/others/attendeAvatar.png";

import { useNavigate } from "react-router-dom";
import EventOverview from "./component/EventOverview";
import EventDetail from "./component/EventDetail";
import EventMission from "./component/EventMission";
import { siteRoutes } from "utils/helpers/enums/routes.enum";

import useUtils from "hooks/useUtils";
import useUsers from "containers/user-management/useHooks";
import Community from "./component/Community";


interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewExperienceEventDetail = () => {
  const [event, setEvent] = useState<any>({});
  const navigate = useNavigate();
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { getEventDetailById } = useUsers();

  const tabs: Tab[] = [
    { name: "Overview", Component: <EventOverview eventData={event} /> },
    { name: "Details", Component: <EventDetail eventData={event} /> },
    { name: "Mission", Component: <EventMission eventData={event} /> },
    { name: "Community", Component: <Community eventId={event?.event?.id} /> },
  ];

  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  console.log(params?.id);
  useEffect(() => {
    getEventDetailById(params?.id, setEvent);
  }, []);
  console.log(event);

  const goToAttendanceView = (id: number, event: any) => {
    navigate(`${siteRoutes.viewExperienceAttendance}?id=${id}`, { state: { event } });
  };

  const goToBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {event?.event?.title || ""}
      </h1>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex gap-4 items-center">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {event?.event?.title || ""}
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md  px-2 py-1">
            {event?.event?.isSession ? "Session" : "Workshop"}
          </p>
          <p className="text-sm font-medium text-captionText">
            {event?.event?.availableSlots || ""} Slots Available
          </p>
        </div>
        <div className="flex items-center gap-4 my-3">
          <div className="flex -space-x-2">
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8  rounded-full border-1 border-white"
            />
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8  rounded-full border-1 border-white"
            />
            <img
              src={attendeAvatar}
              alt="Attendee"
              className="w-8 h-8 rounded-full border-1 border-white"
            />
          </div>
          <span className="text-base font-semibold text-warmGray">
            {event?.event?.joinSlots && event?.event?.availableSlots
              ? `${event.event.joinSlots - event.event.availableSlots} Going`
              : "0 Going"}
          </span>
          <span>
            <button
              onClick={() => goToAttendanceView(event?.event?.id, event)}
              className="px-4 py-2 text-xs bg-lightBlueColor text-white  rounded-lg font-semibold"
            >
              View Attendance
            </button>
          </span>
        </div>
        <div className=" flex gap-6 mt-8">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`text-xs font-semibold pb-1 transition-colors duration-300 ${activeTab.name === tab.name
                ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                : "text-mediumGrayText hover:text-lightBlueColor"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="mt-4">
          {activeTab.name === "Overview" ? (
            <EventOverview eventData={event} />
          ) : activeTab.name === "Details" ? (
            <EventDetail eventData={event} />
          ) : activeTab.name === "Mission" ? (
            <EventMission eventData={event} />
          ) : activeTab.name === "Community" ? (
            <Community eventId={event?.event?.id} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ViewExperienceEventDetail;

